import { render, staticRenderFns } from "./TrackChangesLegend.vue?vue&type=template&id=6a53e3dc"
import script from "./TrackChangesLegend.vue?vue&type=script&lang=js"
export * from "./TrackChangesLegend.vue?vue&type=script&lang=js"
import style0 from "./TrackChangesLegend.vue?vue&type=style&index=0&id=6a53e3dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports